import { initializeApp } from "firebase/app";

import { getMessaging, getToken, onMessage } from "firebase/messaging";

import platform from 'platform';

//Firebase Config values imported from .env file
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
export const messaging = getMessaging(app);


const vapidKey = process.env.REACT_APP_VAPID_KEY

export const requestFCMToken = async () => {
    return Notification.requestPermission()
        .then((permission) => {
            if (permission === "granted") {
                return getToken(messaging, { vapidKey })
            } else {
                throw new Error("Notification not granted")
            }
        })
        .catch((err) => {
            console.log("error getting FCM token", err);
            throw err

        })
}


export const onMessageListener = () => {
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
};


export const getDeviceInfo = () => {
    return {
        deviceType: platform.product || 'desktop', // Desktop if product is undefined
        browser: platform.name,
        os: platform.os?.family,
        osVersion: platform.os?.version,
    };
};


